export enum Themes {
  SciFi = 'sci-fi',
  Friendly = 'friendly'
}
